/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/prop-types */
import React, { useRef, useEffect, useState } from 'react';

import {
  SummaryTitleContainer,
  Title,
  Summary as Container,
  Subtitle,
} from './styles';
import { getProductImage } from '../../helpers';

import notAvailable from '../../assets/images/picture-not-available.jpg';
import momentoInsideSrc from '../../assets/images/momento-inside.png';

const Summary = ({ product, variation, ...props }) => {
  const placeholderRef = useRef();
  const [prodImg, setProdImg] = useState(null);

  const imgSrc = getProductImage(product, variation);

  useEffect(() => {
    const img = document.createElement('img');
    if (imgSrc) {
      img.src = imgSrc;
      setProdImg(img);
    }
  }, [product]);

  return (
    <Container {...props}>
      {!prodImg ? (
        <img
          src={notAvailable}
          alt="Product image not available"
          ref={placeholderRef}
        />
      ) : (
        <img src={imgSrc} alt={product.title} />
      )}

      {product.is_smart && (
        <img
          className="momento-inside"
          src={momentoInsideSrc}
          alt="This product is smart"
        />
      )}

      <SummaryTitleContainer>
        <Title>{product?.title}</Title>
        <Subtitle>(Model {variation?.sku})</Subtitle>
      </SummaryTitleContainer>
    </Container>
  );
};

export default Summary;
